// Auto-generated Table of Contents + Reading Time
(function() {
  const content = document.querySelector('.article-template__content');
  if (!content) return;

  // Reading time
  const words = content.textContent.trim().split(/\s+/).length;
  const minutes = Math.max(1, Math.round(words / 200));
  const readingEl = document.querySelector('.article-reading-time');
  if (readingEl) readingEl.textContent = minutes + ' min læsetid';

  // TOC
  const headings = content.querySelectorAll('h2, h3');
  if (headings.length < 3) return; // Don't show TOC for short articles

  const tocContainer = document.querySelector('.article-toc');
  if (!tocContainer) return;

  const list = document.createElement('ul');
  list.className = 'article-toc__list';

  headings.forEach(function(heading, i) {
    const id = 'section-' + i;
    heading.id = id;

    const li = document.createElement('li');
    li.className = heading.tagName === 'H3' ? 'article-toc__item article-toc__item--sub' : 'article-toc__item';

    const a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = heading.textContent;
    a.className = 'article-toc__link';
    a.addEventListener('click', function(e) {
      e.preventDefault();
      heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    li.appendChild(a);
    list.appendChild(li);
  });

  const title = document.createElement('p');
  title.className = 'article-toc__title';
  title.textContent = 'Indhold';

  tocContainer.appendChild(title);
  tocContainer.appendChild(list);
  tocContainer.style.display = 'block';
})();
